var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:{ 'background-enabled': _vm.enableBackground },attrs:{"version":"1.1","id":"Layer_3","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":_vm.viewBox,"width":_vm.size + 'px'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }